import apiRoles from '@/api/roles'

const state = {
  error: null,
  isSubmitting: false
}

export const mutationTypes = {
  createRoleStart: '[create role] Create role start',
  createRoleSuccess: '[create role] Create role success',
  createRoleFailure: '[create role] Create role failure'
}

export const actionTypes = {
  createRole: '[create role] Create role'
}

const mutations = {
  [mutationTypes.createRoleStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.createRoleSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.createRoleFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  }
}

const actions = {
  [actionTypes.createRole](context, {role}) {
    context.commit(mutationTypes.createRoleStart)
    return new Promise(resolve => {
      apiRoles
        .createRole(role)
        .then(response => {
          context.commit(mutationTypes.createRoleSuccess)
          resolve(response.data)
        })
        .catch(resolve => {
          context.commit(
            mutationTypes.createRoleFailure,
            resolve.response.data.errors
          )
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
